export interface DropoffModel {
  packageSize: number;
  sendingItemKey: number;
  location: {
    longitude: number;
    latitude: number;
    address: string;
    destinationAddress?: string;
  };
  deliveryPlan: number;
  collectCash: number;
  isPhlenuTrustCheckApplied: number;
  isSecurityCoverApplied?: number;
  id: string;
  isCoverEnabled: number;
  isDoorToDoorDropoff: number;
  contactPerson?: string;
  personNumber?: string;
  landMark?: string;
  attachmentInfo?: string;
  attachment?: string;
  attachmentUrl?: string;
  isAttachmentUploaded?: boolean;
  deliveryCharges?: string;
  distance?: string;
  // New fields for dropoff details
  name?: string;
  phone?: string;
  phoneCode?: string;
  sendingItemName?: string;
}

// Legacy interface for backward compatibility
export interface interRegionalOrderModel {
  interRegionalId: string;
  country: string;
  region: string;
  time: string;
  calculateWithCar: number;
  calculateWithTruck: number;
  changeStatus: number;
  conveniencePercentage: number;
  isConvenienceApply: number;
  isHeavyAttachmentApplied: number;
  isLoadingFeeApplied: number;
  isInterRegional: number;
  isPdasWalletApplied: number;
  promoUpdate: number;
  totalCashCollected: number;
  totalDistance: number;
  userId: number;
  damageCoverPercentage: number;
  deliveryCharges: any[];
  dropOff: any[];
  selectedAddress: any[];
  createdAt: { _nanoseconds: number; _seconds: number };
  pickup: any;
  promoResponse: object;
  senderType: string; // 'individual' | 'business'
  pickupType: string; // 'door' | 'self'
  dropoffType: string; // 'door' | 'self'
  deliveryPlan: string; // 'express' | 'regular' | 'saver'
  packageItems: any[];
  handlingOptions: any[];
}

export interface InterRegionalOrderModel {
  regionalId: string;
  time: string;
  changeStatus: number;
  isBusinessInterRegional: number;
  country: string;
  createdAt: {
    seconds: number;
    nanoseconds: number;
  };
  showCsvImportOption: boolean;
  userId: string;
  isDoorToDoorPickup: number;
  pickup: {
    longitude: number;
    latitude: number;
    address: string;
    name?: string;
    phone?: string;
    phoneCode?: string;
  };
  dropOff: DropoffModel[];
  phlenuTrustCheckCommision: number;
  isPhlenutrustCheckEnabled: number;
  isSubtractPriceFromDeliveryFee?: number;
  isSubtractPriceFromPickUpFee?: number;
  paymentMethod?: number;
  // Add the missing properties for main order level
  isCoverEnabled?: number;
  isPhlenuTrustCheckApplied?: number;
  isCashCollectionApplied?: number;
}

export let interRegionalOrderModel: InterRegionalOrderModel = {
  regionalId: '',
  time: '',
  changeStatus: 0,
  isBusinessInterRegional: 0,
  country: '',
  createdAt: { seconds: 0, nanoseconds: 0 },
  showCsvImportOption: false,
  userId: '',
  isDoorToDoorPickup: 0,
  pickup: {
    longitude: 0,
    latitude: 0,
    address: '',
    name: '',
    phone: '',
    phoneCode: ''
  },
  dropOff: [],
  phlenuTrustCheckCommision: 0,
  isPhlenutrustCheckEnabled: 0,
  paymentMethod: 0,
  isSubtractPriceFromDeliveryFee: 0,
  isSubtractPriceFromPickUpFee: 0,
  // Add default values for the missing properties
  isCoverEnabled: 0,
  isPhlenuTrustCheckApplied: 0,
  isCashCollectionApplied: 0,
}
